import { createApi } from '@reduxjs/toolkit/query/react';

import consultingCompanyApi from '@/slices/consultingCompany/consultingCompany.api';
import enterpriseApi from '@/slices/enterprises/enterprise.api';

import { symfonyBaseQuery } from '@/services/SymfonyClient';
import { CompanyLicense } from '@/types/companies.types';

type UpdateCompanyLicenseInput = {
  companyId: string;
  licensesCount: number;
};

const licensingApi = createApi({
  baseQuery: symfonyBaseQuery({
    baseUrl: '/api',
  }),
  reducerPath: 'licensing',
  endpoints: (build) => ({
    updateCompanyLicense: build.mutation<
      CompanyLicense,
      UpdateCompanyLicenseInput
    >({
      query: ({ companyId, licensesCount }) => ({
        url: `/admin/companies/${companyId}/license`,
        method: 'PATCH',
        data: {
          licensesCount,
        },
      }),
      async onQueryStarted({ companyId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;

          dispatch(
            enterpriseApi.util.invalidateTags([
              { type: 'Enterprise', id: companyId },
            ]),
          );
          dispatch(
            consultingCompanyApi.util.invalidateTags([
              { type: 'ConsultingCompany', id: companyId },
            ]),
          );
        } catch {
          // Ignore cache invalidation when update request fails.
        }
      },
    }),
  }),
});

export default licensingApi;
